import React, { useEffect, useState } from 'react';
import { Close } from "@mui/icons-material";
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import api from '../../services/api';

interface ValidacaoMapaModalProps {
  uidRegistro: string;
  onClose: () => void;
}

const CENTRO_PADRAO: [number, number] = [-22.9, -48.4]; // interior de SP, região onde os projetos-piloto atuam

// Mostra o ponto do registro sendo revisado (destaque, maior e em laranja)
// junto com os demais registros JÁ VALIDADOS do mesmo pescador (verde) —
// ajuda o validador a perceber quando o local informado foge do padrão
// esperado pra aquele pescador.
const ValidacaoMapaModal: React.FC<ValidacaoMapaModalProps> = ({ uidRegistro, onClose }) => {
  const [registros, setRegistros] = useState<any[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    api.get(`/pesca/registros/${uidRegistro}/mapa-validacao`)
      .then((res) => setRegistros(res.data.data.registros))
      .catch((err) => setErro(err?.response?.data?.message || 'Não foi possível carregar o mapa.'))
      .finally(() => setCarregando(false));
  }, [uidRegistro]);

  const destaque = registros.find((r) => r.destaque);
  const centro: [number, number] = destaque ? [destaque.lat, destaque.lng] : (registros[0] ? [registros[0].lat, registros[0].lng] : CENTRO_PADRAO);

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <h2 style={{ margin: 0, color: 'var(--green-700, #00b37e)', fontSize: '1.1rem' }}>Local no mapa</h2>
          <Close style={{ cursor: 'pointer' }} onClick={onClose} />
        </div>

        {erro && <p style={{ color: '#f75a68', fontSize: '0.85rem' }}>{erro}</p>}
        {!erro && !carregando && registros.length === 0 && (
          <p style={{ color: '#999', fontSize: '0.85rem' }}>
            Nenhum ponto pra mostrar — esse registro ainda não tem local com coordenada resolvida.
          </p>
        )}

        <div style={{ height: '55vh', minHeight: '320px', borderRadius: '10px', overflow: 'hidden' }}>
          <MapContainer center={centro} zoom={destaque ? 11 : 7} style={{ width: '100%', height: '100%' }}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {registros.map((r) => (
              <CircleMarker
                key={r.uid_pesca_registro}
                center={[r.lat, r.lng]}
                radius={r.destaque ? 9 : 6}
                pathOptions={
                  r.destaque
                    ? { color: '#e08a00', weight: 3, fillColor: '#e08a00', fillOpacity: 0.85 }
                    : { color: '#00b37e', weight: 2, fillColor: '#00b37e', fillOpacity: 0.6 }
                }
              >
                <Popup>
                  <strong>{r.nome_local || 'Local não identificado'}</strong><br />
                  {new Date(r.data_inicio).toLocaleDateString('pt-BR')}<br />
                  {r.destaque ? 'Registro sendo revisado' : 'Já validado'}
                </Popup>
              </CircleMarker>
            ))}
          </MapContainer>
        </div>

        <div style={{ display: 'flex', gap: '14px', marginTop: '10px', fontSize: '0.78rem', color: '#666' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#e08a00', display: 'inline-block' }} />
            Este registro
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ width: 10, height: 10, borderRadius: '50%', background: '#00b37e', display: 'inline-block' }} />
            Outros já validados deste pescador
          </span>
        </div>
      </div>
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1000,
};
const modalStyle: React.CSSProperties = {
  background: '#fff', borderRadius: '12px', padding: '20px',
  width: '90%', maxWidth: '640px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
};

export default ValidacaoMapaModal;
